module.exports = __webpack_public_path__ + "img/whats-new-8_en.6eb2f52.jpg";